// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__AniVy","title":"BackImages_title__1Zors","images":"BackImages_images__33B58"};